import { useQuery } from '@apollo/client';
import { Partner } from '@bybeam/platform-types';
import ThemeProvider from '@platform-ui-common/components/ThemeProvider/index.js';
import React, { ReactNode, useContext } from 'react';
import { useParams } from 'react-router';
import Loading from '../../components/Loading/index.js';
import GetPartnerQuery from '../../graphql/queries/GetPartnerQuery.graphql';

// Only exported for use in tests/mocks; do NOT reference directly in prod code
export const PartnerContext = React.createContext<Partner>(undefined);

export function PartnerProvider({ children }: { children: ReactNode }): JSX.Element {
  const { partnerId: externalId } = useParams<{ partnerId: string }>();
  const { data, loading } = useQuery<{ partners: { partners: Partner[] } }, { externalId: string }>(
    GetPartnerQuery,
    { variables: { externalId } },
  );

  // TODO: Redirect to some fatal error page if the partner doesn't exist
  return (
    <PartnerContext.Provider value={data?.partners.partners[0]}>
      <ThemeProvider>{loading ? <Loading size="XXL" fullPage /> : children}</ThemeProvider>
    </PartnerContext.Provider>
  );
}

export default function usePartner(): Partner {
  return useContext(PartnerContext);
}
